<section>
  <div>
    <h1 class="rds-heading-1">Welcome, {{ userName }}!</h1>
    <p class="rds-paragraph">
      Please select a profile to get started with C-Cube.
    </p>
  </div>
</section>